import { getConfigName } from "@helpers/funciones";
import { RegistroDatosPersonales } from "./RegistroDatosPersonales";
import { RegistroDatosPersonalesMercader } from "./RegistroDatosPersonalesMercader";
import { RegistroDatosPersonalesWuWei } from "./RegistroDatosPersonalesWuWei";

/**
 * Pantallas de "datos personales" del wizard v2 propias de una empresa, por tenant. Igual que
 * `cotizadoresV2PorTipo`: si el tenant no está aquí se usa `RegistroDatosPersonales`.
 */
const registroDatosPersonalesPorEmpresa: Record<string, React.FC> = {
  mercader: RegistroDatosPersonalesMercader,
  wuwei: RegistroDatosPersonalesWuWei,
};

/**
 * Monta la pantalla de datos personales del tenant (ver `registroDatosPersonalesPorEmpresa`) o, si
 * no tiene una propia, `RegistroDatosPersonales`.
 */
export const RegistroDatosPersonalesPorEmpresa = () => {
  const Component = registroDatosPersonalesPorEmpresa[getConfigName(window.location.href)] ?? RegistroDatosPersonales;
  return <Component />;
};
